import { render, staticRenderFns } from "./LayListJournal.vue?vue&type=template&id=19fbe52c&scoped=true&"
import script from "./LayListJournal.vue?vue&type=script&lang=js&"
export * from "./LayListJournal.vue?vue&type=script&lang=js&"
import style0 from "./LayListJournal.vue?vue&type=style&index=0&id=19fbe52c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fbe52c",
  null
  
)

export default component.exports